module.exports = __webpack_public_path__ + "static/media/right-green-arrow.88be208a.svg";